import React from "react";
import { errorToast } from "./common/showtoast";
import PageHeader from "./common/pageheader";
import ApiRequest from "./common/restservice";

export default class CWallet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
    };
  }
  componentDidMount() {
    //this.GetDashboardDetails();
    this.GetTransactions();
  }
  async GetTransactions() {
    let res = await ApiRequest("GetCashWallet.asp", "GET", null, {
      Authorization: localStorage.getItem("token"),
    });
    console.log(res);
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        this.props.history.push("/login");
      }
      return;
    }
    this.setState({ tableData: res.items });
  }
  render() {
    return (
      <div>
        <PageHeader title="Payout Wallet" />

        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h3
                  className="card-title text-color-1"
                  style={{ fontWeight: "200", fontSize: "22px" }}
                >
                  Payout Wallet Transactions
                </h3>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top"
                    style={{ textAlign: "center" }}
                  >
                    <thead className="">
                      <tr>
                        <th>S.No</th>
                        <th>Date</th>
                        <th>Description</th>
                        <th>Debit</th>
                        <th>Credit</th>
                        <th>Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.tableData.length <= 0 ? (
                        <tr>
                          <td colSpan="6">No Details Found</td>
                        </tr>
                      ) : (
                        this.state.tableData.map((item, index) => (
                          <tr key={index}>
                            <td className="tabletd">{index + 1}</td>
                            <td>{item.date}</td>
                            <td>{item.Description}</td>
                            <td>{item.Debit}</td>
                            <td>{item.Credit}</td>
                            <td>{item.Balance}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
